import store from '~/store'
import router from '~/router'

export default async (to, from, next) => {
  if (!store.getters['auth/check']) {
    next({ name: 'login' })
  } else {
      let start = moment()._d.getTime();
      await Promise.all([
          store.dispatch('auth/fetchUser'),
          (!store.getters['regions/regions'].length) ? store.dispatch('regions/fetch') : Promise.resolve,
          (!store.getters['operators/call_center'].length) ? store.dispatch('operators/fetch') : Promise.resolve,
          (!store.getters['sales_managers/all'].length) ? store.dispatch('sales_managers/fetch') : Promise.resolve,
          (!store.getters['credit_managers/all'].length) ? store.dispatch('credit_managers/fetch') : Promise.resolve,
          (!store.getters['sources/all'].length) ? store.dispatch('sources/fetch') : Promise.resolve,
          (!store.getters['banks/all'].length) ? store.dispatch('banks/fetch') : Promise.resolve,
          (!store.getters['platforms/all'].length) ? store.dispatch('platforms/fetch') : Promise.resolve,
          (!store.getters['affiliate_program_categories/all'].length) ? store.dispatch('affiliate_program_categories/fetch') : Promise.resolve,
      ])
      await store.dispatch('columns/load');
      // Если токен в базе и токен текущий совпадают то ОК, иначе идем на стр входа
      let user = store.getters['auth/user'];
      let token = store.getters['auth/token'];
      if (user && user.token !== token) {
          store.dispatch('auth/onLogout')
              .then(() => {
                  router.push({name: 'login'})
                      .then(() => {
                          window.location.reload();
                      });
              })
      }
      console.log(moment()._d.getTime() - start);
      next()
  }
}
